import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import HeroSlider from './components/HeroSlider';
import Productions from './components/Productions';
import Videos from './components/Videos';
import Services from './components/Services';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FanCorner from './components/FanCorner';
import ServiceDetail from './components/ServiceDetail';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import CookiesPolicy from './components/CookiesPolicy';
import { doc, updateDoc, setDoc, increment } from 'firebase/firestore';
import { db } from './firebase';
import './index.css';

function App() {
  const [page, setPage] = useState('home'); // 'home' | 'fancorner' | 'service'
  const [activeServiceId, setActiveServiceId] = useState(null);

  // Track visitors
  useEffect(() => {
    const trackVisitor = async () => {
      if (!localStorage.getItem('mms_hasVisited')) {
        const statsRef = doc(db, 'stats', 'visitors');
        try {
          await updateDoc(statsRef, { count: increment(1) });
        } catch (error) {
          if (error.code === 'not-found') {
            await setDoc(statsRef, { count: 1 });
          }
        }
        localStorage.setItem('mms_hasVisited', 'true');
      }
    };
    trackVisitor();
  }, []);

  useEffect(() => {
    const checkHash = () => {
      const hash = window.location.hash;
      if (hash === '#/fancorner') {
        setPage('fancorner');
      } else if (hash.startsWith('#/service/')) {
        const svcId = hash.split('#/service/')[1];
        setActiveServiceId(svcId);
        setPage('service');
      } else if (hash === '#/privacy') {
        setPage('privacy');
      } else if (hash === '#/terms') {
        setPage('terms');
      } else if (hash === '#/cookies') {
        setPage('cookies');
      } else {
        setPage('home');
      }
    };
    checkHash();
    window.addEventListener('hashchange', checkHash);
    return () => window.removeEventListener('hashchange', checkHash);
  }, []);

  const handleServiceClick = (svcId) => {
    window.location.hash = `#/service/${svcId}`;
  };

  const handleBackToServices = () => {
    window.location.hash = '#services';
    setTimeout(() => {
      const el = document.getElementById('services');
      if (el) el.scrollIntoView({ behavior: 'smooth' });
    }, 100);
  };

  if (page === 'fancorner') {
    return (
      <div className="relative bg-brand-black min-h-screen">
        <Navbar showFanCorner />
        <FanCorner />
        <Footer />
      </div>
    );
  }

  if (page === 'service') {
    return (
      <div className="relative bg-brand-black min-h-screen">
        <Navbar />
        <ServiceDetail serviceId={activeServiceId} onBack={handleBackToServices} />
        <Footer />
      </div>
    );
  }

  if (page === 'privacy') {
    return (
      <div className="relative bg-brand-black min-h-screen">
        <Navbar />
        <PrivacyPolicy />
        <Footer />
      </div>
    );
  }

  if (page === 'terms') {
    return (
      <div className="relative bg-brand-black min-h-screen">
        <Navbar />
        <TermsOfUse />
        <Footer />
      </div>
    );
  }

  if (page === 'cookies') {
    return (
      <div className="relative bg-brand-black min-h-screen">
        <Navbar />
        <CookiesPolicy />
        <Footer />
      </div>
    );
  }

  return (
    <div className="relative bg-brand-black min-h-screen">
      <Navbar />
      <main>
        <HeroSlider />
        <Productions />
        <Videos />
        <Services onServiceClick={handleServiceClick} />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;
